import { render, staticRenderFns } from "./ChatBoxWidget.vue?vue&type=template&id=65a723de&scoped=true&"
import script from "./ChatBoxWidget.vue?vue&type=script&lang=js&"
export * from "./ChatBoxWidget.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxWidget.vue?vue&type=style&index=0&id=65a723de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a723de",
  null
  
)

export default component.exports